import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className='text-center font-bold text-4xl'>This Page is not Available</h1>
        </div>
    );
};

export default NotFound;